
export default {
  userStatus (state, user) {
    if (user) {
      state.loginInfo = user
      state.logined = true
    } else if (user === null) {
      state.loginInfo = {admin_type: 'guest', name: '游客', authority: []}
      state.logined = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js